import { createSlice, nanoid } from "@reduxjs/toolkit";

const initialState = [
  {
    name: "Frozen yoghurt",
    calories: 159,
    fat: 6.0,
    user: "Raj",
    rating: 4.0,
  },
  {
    name: "Ice cream sandwich",
    calories: 237,
    fat: 5.0,
    user: "Jai",
    rating: 4.3,
  },
  {
    name: "Eclair",
    calories: 262,
    fat: 16.0,
    user: "Jaipur",
    rating: 6.0,
  },
  {
    name: "Cupcake",
    calories: 305,
    fat: 3.7,
    user: "Royal",
    rating: 4.3,
  },
  {
    name: "Gingerbread",
    calories: 356,
    fat: 16.0,
    user: "Orchid",
    rating: 3.9,
  },
];

export const ApiDataSlice = createSlice({
  name: "ApiData",
  initialState: {
    data: initialState, // The full data
    filteredData: initialState, // Initially, filteredData is the same as data
  },
  reducers: {
    insertApi: (state, action) => {
      const Api = {
        id: nanoid(),
        ...action.payload,
      };
      state.ApiList.push(Api);
    },
    removeApi: (state, action) => {
      state.ApiList = state.ApiList.filter(
        (item) => item.id !== action.payload
      );
    },
    upgradeApi: (state, action) => {
      state.ApiList = state.ApiList.map((item) =>
        item.id === action.payload?.id ? action.payload : item
      );
    },
    searchApiData: (state, action) => {
      const searchTerm = action.payload.toLowerCase();
      // Filter the data by `user` (or any field) based on the search term
      state.filteredData = state.data.filter((item) =>
        item.user.toLowerCase().includes(searchTerm)
      );
    },
  },
});

export const { insertApi, removeApi, upgradeApi, searchApiData } =
  ApiDataSlice.actions;

export default ApiDataSlice.reducer;
